import React from 'react';
import PeoplePicker, { mapDbUserForPeoplePicker } from '../formFields/PeoplePicker';

const TemplatePermissionItem = ({name, location , users, onSelectedUsers}) => {

    return (
        <div className='settings-item'>
            <div className="settings-item-title">{name} ({location.name})</div>
            <PeoplePicker
                defaultUsers={users.map(u => mapDbUserForPeoplePicker(u))}
                onSelectedUsers={onSelectedUsers} 
                includeGroups={true}
            />
        </div>
    )

}

export default TemplatePermissionItem;


// WEBPACK FOOTER //
// ./src/components/Settings/TemplatePermissionItem.js